import { BaseElementToSimpleSapElementMapper } from '../baseElementToSimpleSapElementMapper';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';
import Element from '@/models/element';

export class CtBodyToSimpleSapElementMapper
    extends BaseElementToSimpleSapElementMapper {

    public map(element: Element): ISimpleSapElement[] {
        const width = Number(this.body.model.split('_')[2].split('.')[0]);
        const code = width === 550 ? 'SON' : 'SOW';
        const dim1 = 6;
        const dim2 = width === 550 ? 1 : 2;
        const type = this.formatType(code, dim1, dim2);
        const color = this.toColor(element);
        return [SimpleSapElement.ELEMENT(type, color)];
    }
}